import { Component, Input, OnInit } from '@angular/core';
import { ExportEigentum } from '../../../../../core/batch-auftrag-api';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { CapFormControlComponent } from '../../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../../shared/directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-select-eigentum',
  templateUrl: './select-eigentum.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: NgForm
    }
  ],
  imports: [CapFormControlComponent, FormsModule, MetaDisablerDirective, MetaValidatorDirective, TranslatePipe]
})
export class SelectEigentumComponent implements OnInit {
  @Input()
  model: ExportEigentum;

  @Input()
  disabled: boolean;

  constructor() {}

  ngOnInit() {}
}
